module.exports = __webpack_public_path__ + "static/media/Laurana_Article_Image.d7a14efe.jpg";